var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrayTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5,198.992a11.123,11.123,0,0,0,4.455-.905,11.582,11.582,0,0,0,6.136-6.136,11.483,11.483,0,0,0,0-8.938,11.489,11.489,0,0,0-2.472-3.65,11.784,11.784,0,0,0-3.664-2.457,11.483,11.483,0,0,0-8.938,0,11.478,11.478,0,0,0-6.107,6.107,11.483,11.483,0,0,0,0,8.938,11.784,11.784,0,0,0,2.457,3.664,11.489,11.489,0,0,0,3.65,2.472A11.194,11.194,0,0,0,91.5,198.992Zm0-1.724a9.763,9.763,0,1,1,6.912-2.86A9.4,9.4,0,0,1,91.5,197.267ZM91.5,187.5Z",
    fill: "#918F90",
    transform: "translate(-104 -229) scale(1.3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6,193.286l10.585-10.648-1.721-1.693L89.6,189.862l-4.488-4.515-1.683,1.693ZM91.8,186.438Z",
    transform: "translate(-76.804 -171.442)",
    fill: "#918F90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayTick);
export default __webpack_public_path__ + "static/media/gray_tick.1b686829e5a1a3d7425edcca47e604a0.svg";
export { ForwardRef as ReactComponent };